import { render, staticRenderFns } from "./Village.vue?vue&type=template&id=43c4051f&scoped=true&"
import script from "./Village.vue?vue&type=script&lang=js&"
export * from "./Village.vue?vue&type=script&lang=js&"
import style0 from "./Village.vue?vue&type=style&index=0&id=43c4051f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c4051f",
  null
  
)

export default component.exports